/**
 * Chronos Watch Shop - Mock Data
 * 
 * This file contains sample product and testimonial data for use when
 * the backend API is unavailable (e.g., static deployment on Netlify).
 * 
 * In production with a backend, this data is fetched from the API instead.
 */

// ============================================
// Product Catalog
// ============================================

export const MOCK_PRODUCTS = [
  {
    id: "prod-1",
    name: "The Sovereign Chronograph",
    description: "A masterpiece of Swiss engineering featuring a 42mm case crafted from 18k rose gold. The intricate dial showcases three sub-dials with a perpetual calendar complication.",
    price: 28500,
    image: "https://images.unsplash.com/photo-1634113709155-5c2756711384?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    category: "Chronograph",
    specs: {
      case: "42mm 18k Rose Gold",
      movement: "Automatic",
      water_resistance: "100m",
      crystal: "Sapphire"
    },
    sizes: ["38mm", "40mm", "42mm", "44mm"]
  },
  {
    id: "prod-2",
    name: "The Diver 300M",
    description: "Engineered for the depths, this professional dive watch features a helium escape valve and luminescent markers that glow brilliantly in the darkest waters.",
    price: 12800,
    image: "https://images.unsplash.com/photo-1691865179028-1729b766a5cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    category: "Diver",
    specs: {
      case: "44mm Titanium",
      movement: "Automatic",
      water_resistance: "300m",
      crystal: "Sapphire"
    },
    sizes: ["42mm", "44mm", "46mm"]
  },
  {
    id: "prod-3",
    name: "The Aviator Chrono",
    description: "Inspired by vintage pilot watches, this timepiece combines heritage aesthetics with modern precision. Features a slide rule bezel and dual time zone functionality.",
    price: 18900,
    image: "https://images.unsplash.com/photo-1764243910471-4161c42fd29c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    category: "Pilot",
    specs: {
      case: "43mm Stainless Steel",
      movement: "Automatic",
      water_resistance: "50m",
      crystal: "Sapphire"
    },
    sizes: ["41mm", "43mm", "45mm"]
  },
  {
    id: "prod-4",
    name: "The Classic Dress",
    description: "Understated elegance in its purest form. This ultra-thin dress watch features a guilloche dial and hand-finished movement visible through the exhibition caseback.",
    price: 22400,
    image: "https://images.unsplash.com/photo-1623998021661-dc7555b2213d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    category: "Dress",
    specs: {
      case: "39mm White Gold",
      movement: "Manual",
      water_resistance: "30m",
      crystal: "Sapphire"
    },
    sizes: ["36mm", "38mm", "39mm", "40mm"]
  },
  {
    id: "prod-5",
    name: "The Heritage Tourbillon",
    description: "The pinnacle of horological achievement. This grand complication features a flying tourbillon at 6 o'clock, showcasing 72 hours of power reserve.",
    price: 85000,
    image: "https://images.unsplash.com/photo-1628608570910-5ba45093d2c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    category: "Grand Complication",
    specs: {
      case: "41mm Platinum",
      movement: "Manual Tourbillon",
      water_resistance: "30m",
      crystal: "Sapphire"
    },
    sizes: ["39mm", "41mm"]
  },
  {
    id: "prod-6",
    name: "The Noir Skeleton",
    description: "Architecture for the wrist. This skeletonized masterpiece reveals every gear and spring through its open-worked dial, finished in striking black DLC coating.",
    price: 34500,
    image: "https://images.unsplash.com/photo-1691580424120-b7973081a64b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    category: "Skeleton",
    specs: {
      case: "42mm DLC Steel",
      movement: "Automatic",
      water_resistance: "50m",
      crystal: "Sapphire"
    },
    sizes: ["40mm", "42mm", "44mm"]
  }
];

// ============================================
// Customer Testimonials
// ============================================

export const MOCK_TESTIMONIALS = [
  {
    id: "test-1",
    name: "Alexander Wright",
    title: "CEO, Wright Capital",
    content: "The Sovereign Chronograph is more than a timepiece—it's a statement. The craftsmanship is extraordinary, and the service was impeccable.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200"
  },
  {
    id: "test-2",
    name: "Victoria Chen",
    title: "Art Director",
    content: "I've collected watches for 20 years. This collection represents the finest balance of heritage and innovation I've encountered.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=200"
  },
  {
    id: "test-3",
    name: "James Morrison",
    title: "Professional Diver",
    content: "The Diver 300M accompanied me to depths of 280 meters. Flawless performance, exceptional build quality. A true professional's tool.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=200"
  }
];
